import { createContainer } from 'react-sweet-state';

import { type CommonContainerProps } from 'src/lib/sweetState';

import { type Actions, AdvancedStore, type State } from './AdvancedStore';

export const AdvancedStoreContainer = createContainer<State, Actions, CommonContainerProps<State>>(
  AdvancedStore,
  {
    onInit:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
    onUpdate:
      () =>
      ({ setState }, { state }) => {
        if (state) {
          setState(state);
        }
      },
  }
);
